import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-stacked-line',
  templateUrl: './stacked-line.component.html',
  styleUrls: ['./stacked-line.component.css']
})
export class StackedLineComponent implements OnInit {

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._plotBar();
      // this.chartOption?.resize();
    }, 1);
  }
  
  constructor() { }
chartOption:any
  ngOnInit(): void {
    this._plotBar();
   }

  _plotBar(){
    this.chartOption = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['CRA02','CRA01','PB01','VC01','CRA03'],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
        height:'80%'
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      },
      yAxis: {
        type: 'value',
        interval: 5,
        max:30
      },
      series: [
        {
          name: 'CRA02',
          type: 'line',
          data: [8, 18, 7, 17, 14, 10, 13],
          smooth: true
        },
        {
          name: 'CRA01',
          type: 'line',
          data: [13, 14, 19, 16, 12, 18, 15],
          smooth: true
        },
        {
          name: 'PB01',
          type: 'line',
          data: [7, 15, 6, 10, 5, 11, 18],
          smooth: true
        },
        {
          name: 'VC01',
          type: 'line',
          data: [9, 10, 12, 11, 7, 17, 14],
          smooth: true
        },
        {
          name: 'CRA03',
          type: 'line',
          data: [14, 12, 15, 7, 15, 18, 12],
          smooth: true
        }
      ]
    };
  }

}
